import { isDeepEqual } from "@suse-o11y/is-deep-equal";

export interface DropdownFilterItem {
	value: string;
	label: string;
}

export const DEFAULT_DROPDOWN_FILTER: DropdownFilterItem = {
	value: "",
	label: "Any",
};

export const isDefaultDropdownFilter = isDeepEqual<DropdownFilterItem>(DEFAULT_DROPDOWN_FILTER);
